{
  "data": [
    [
      "Returning service member care",
      "Post-9/11 Veterans (OEF, OIF, OND) transition and care management services",
      [],
      "transitionCounseling",
      "Social programs and services",
      true,
      true,
      true,
      false,
      469,
      "If you're returning from military service, we can help you readjust to civilian life and get started with VA health care. We can also help connect you with programs like mental health services and education and career counseling.",
      "",
      ["returning service member cares"],
      [
        "returing service membber care",
        "retuning service memmber care",
        "returing servuce member care",
        "returning sevrice member care"
      ],
      [
        "Veteran transition care",
        "service member support",
        "transition assistance",
        "post-service care"
      ]
    ],
    [
      "Mental health care",
      "Behavioral health",
      [
        "addiction",
        "depression",
        "anxiety",
        "trauma",
        "PTSD",
        "bipolar disorder",
        "schizophrenia",
        "OCD"
      ],
      "mentalHealth",
      "Mental health care",
      true,
      false,
      true,
      false,
      443,
      "If you're struggling with issues like PTSD, depression, grief, anger or trauma, we offer counseling and other support. All VA health care facilities offer same-day help. You may qualify even without enrolling in VA health care.",
      "If you're struggling with issues like PTSD, depression, grief, anger, or trauma, we can help. We offer counseling and other support. ",
      ["mental health cares"],
      [
        "metal health care",
        "mental helth care",
        "mentl health care",
        "mental healt care"
      ],
      [
        "mental well-being",
        "psychological care",
        "behavioral health",
        "mental health services",
        "post-traumatic stress disorder",
        "post traumatic stress disorder",
        "panic"
      ]
    ],
    [
      "Suicide prevention",
      "Veterans Crisis Line",
      [],
      "suicidePrevention",
      "Mental health care",
      true,
      false,
      true,
      false,
      442,
      "Call our Veterans Crisis Line at 988 and press 1 for free, private help anytime 24/7. Our local suicide prevention coordinators can also connect you with ongoing counseling and services.",
      "Call the Military and Veterans Crisis Line at 988 and press 1 for free, private help anytime 24/7. Our local suicide prevention coordinators can also connect you with ongoing counseling and services.",
      ["suicide preventions"],
      [
        "sucide prevention",
        "sidide prevention",
        "suucide prevention",
        "suicide preevention"
      ],
      [
        "suicide hotline",
        "crisis prevention",
        "suicide intervention",
        "prevention hotline",
        "VCL",
        "988"
      ]
    ],
    [
      "Register for care",
      null,
      [],
      "registerForCare",
      "Non-clinical services",
      null,
      null,
      true,
      null,
      415,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Addiction and substance use care",
      "Drug and alcohol treatment and rehabilitation",
      [],
      "addiction",
      "Mental health care",
      true,
      false,
      true,
      false,
      396,
      "We can help you overcome substance use problems from unhealthy alcohol use to life-threatening addiction. We match our services like counseling, group therapy or medication to your specific needs.",
      "",
      ["addictions and substance uses"],
      [
        "addictionn",
        "substnce use care",
        "addction and substance use care",
        "adiction and substance care"
      ],
      [
        "addiction treatment",
        "substance abuse care",
        "drug treatment",
        "alcohol rehabilitation",
        "drug rehab",
        "rehab",
        "alcohol treatment",
        "detox"
      ]
    ],
    [
      "PTSD care",
      null,
      [],
      "ptsd",
      "Mental health care",
      true,
      null,
      true,
      null,
      390,
      "If you have symptoms of PTSD after a traumatic event, we can help. We offer assessment and treatment support such as private counseling, group therapy and medication. It's never too late to get help.",
      "",
      ["PTSD cares"],
      ["PTSD car", "PTDS care", "PSTD care", "PTS care"],
      [
        "trauma support",
        "PTSD treatment",
        "trauma recovery",
        "post-traumatic care",
        "post-traumatic stress disorder",
        "post traumatic stress disorder",
        "mental health"
      ]
    ],
    [
      "Military sexual trauma care",
      null,
      [],
      "militarySexualTrauma",
      "Mental health care",
      true,
      false,
      true,
      false,
      388,
      "Military sexual trauma can happen to anyone. If you experienced sexual assault or harassment during military service no matter when you served we provide counseling and treatment.",
      "",
      ["military sexual trauma cares"],
      [
        "military sexual ttrauma care",
        "militry sexul trauma care",
        "military sexal trauma care",
        "miltary sexual trauma care"
      ],
      [
        "MST support",
        "trauma care",
        "sexual trauma services",
        "military abuse support"
      ]
    ],
    [
      "Medical records",
      null,
      [],
      "medicalRecords",
      "Non-clinical services",
      null,
      null,
      true,
      null,
      343,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Grief and bereavement counseling",
      null,
      [],
      "griefCounseling",
      null,
      true,
      true,
      false,
      false,
      309,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Couples and family counseling",
      null,
      [],
      "familyCounseling",
      "Other services",
      true,
      null,
      true,
      null,
      305,
      "We offer couples and family counseling to support you as you work toward meeting your goals.",
      "",
      ["couples and family counselings", "couples therapy"],
      [
        "copules and famliy counseling",
        "couples and family counceling",
        "couple and family councilling",
        "couples and family conseling"
      ],
      [
        "couple therapy",
        "family therapy",
        "relationship counseling",
        "marital counseling",
        "marriage counseling"
      ]
    ],
    [
      "Community engagement",
      null,
      [],
      "communityEngagement",
      "Other services",
      true,
      false,
      true,
      false,
      304,
      "We provide private organizations and community agencies education on our Veteran community and military culture. Together, we build referral networks to expand support for Veterans, service members, and their families.",
      "We teach private organizations and community agencies about Veterans and military culture. By working together, we can create a network of people who can offer more help to the Veteran and military community.",
      ["community engagements"],
      [
        "comunity engagement",
        "commnity engagemant",
        "commuity engagement",
        "comnity engagement"
      ],
      [
        "community outreach",
        "community programs",
        "engagement services",
        "public engagement",
        "community support"
      ]
    ],
    [
      "Veteran connections",
      null,
      [],
      "veteranConnections",
      null,
      true,
      null,
      null,
      null,
      302,
      "We can help connect you to VA and community resources that will support you in achieving your goals.",
      "",
      [],
      [],
      []
    ],
    [
      "Billing and insurance",
      null,
      [],
      "billing",
      "Non-clinical services",
      null,
      null,
      true,
      null,
      299,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Telehealth",
      "Video visits, remote care, care by telephone",
      [],
      "telehealth",
      "Other services",
      true,
      false,
      true,
      false,
      295,
      "With VA telehealth, you can get care from your health providers without having to travel. Get checkups and treatment, talk about your care and more from home or elsewhere.",
      "With TRICARE telehealth, you can get care from your health providers without having to travel. Get checkups and treatment, talk about your care and more from home or elsewhere.",
      ["telehealths"],
      ["telehelth", "telhealth", "telehalth", "teleheath"],
      [
        "telemedicine",
        "virtual visits",
        "remote health",
        "video consultations",
        "virtual care"
      ]
    ],
    [
      "Homeless Veteran care",
      "Transitional and supportive housing, HUD-VASH",
      [],
      "homeless",
      "Social programs and services",
      true,
      true,
      true,
      false,
      280,
      "If you're homeless or at risk of becoming homeless, we can help. We offer many programs and services, including free health care. And we can help you connect with resources in your community.",
      "",
      ["homeless Veteran cares"],
      [
        "homless Veteran care",
        "homeles Veteran care",
        "homeless Vetern care",
        "homeless Veteran cae"
      ],
      [
        "homeless services",
        "Veteran housing",
        "transitional housing",
        "support services",
        "housing support"
      ]
    ],
    [
      "Women Veteran care",
      null,
      [
        "women's primary care",
        "mental health",
        "obstetrics",
        "gynecology",
        "pap smear",
        "mammogram"
      ],
      "womensHealth",
      "Primary care",
      true,
      false,
      true,
      false,
      249,
      "We offer women's health services to meet your specific needs such as disease screenings, mental health treatment, recovery from military sexual trauma, maternity care and female-specific medical equipment.",
      "",
      ["women Veteran cares"],
      [
        "Womn Veteran care",
        "Wome Veteran cae",
        "Women Veteran carr",
        "Wmen Veteran care"
      ],
      [
        "female Veteran care",
        "women 's health",
        "women 's services",
        "Veteran women 's care",
        "birth control",
        "OB",
        "gyn",
        "ob/gyn",
        "menopause",
        "fertility",
        "maternity"
      ]
    ],
    [
      "Whole health",
      "Patient-centered care",
      [],
      "wholeHealth",
      "Other services",
      true,
      false,
      true,
      false,
      221,
      "Whole health puts you at the center of care, rather than your illnesses or conditions. We work with you to develop a personalized health plan based on your values, needs, and goals.",
      "",
      ["whole healths"],
      ["whol health", "whle health", "wole health", "wholle health"],
      [
        "holistic health",
        "whole care",
        "comprehensive health",
        "integrative health",
        "well being",
        "well-being",
        "circle of health",
        "personal health plan"
      ]
    ],
    [
      "LGBQ+ Veteran care",
      "Lesbian, gay, bisexual, those with gender dysphoria, and queer/questioning identities",
      [],
      "lgbtq",
      "Social programs and services",
      true,
      false,
      true,
      false,
      219,
      "VA serves all Veterans. The Veteran care coordinator at your VA health care facility can help connect you to services in a safe environment.",
      "",
      ["LGBQ+ Veteran cares"],
      [
        "LGB Veteran care",
        "LBGQ+ Veteran care",
        "LGQ+ Veteran care",
        "LGBQ care"
      ],
      [
        "LGBTQ Veteran care",
        "identity care",
        "diverse identities support",
        "gender health",
        "LGBT",
        "transgender"
      ]
    ],
    [
      "Minority Veteran care",
      null,
      [],
      "minorityCare",
      "Social programs and services",
      true,
      false,
      true,
      false,
      192,
      "We offer resources and support for minority Veterans to help address your specific needs with benefits and services at VA.",
      "",
      ["minority Veteran cares"],
      [
        "minorty Veteran care",
        "minority Vteran care",
        "minority Vetern care",
        "minority Veternare care"
      ],
      [
        "minority services",
        "Veteran minority care",
        "diverse Veteran support",
        "minority health",
        "Black",
        "African American",
        "Native American",
        "Alaska Native",
        "Tribal",
        "Indian",
        "Asian",
        "Latino",
        "Hispanic"
      ]
    ],
    [
      "Veteran Readiness and Employment programs",
      "Job and career training programs",
      [],
      "employmentPrograms",
      "Other services",
      true,
      true,
      true,
      false,
      165,
      "We can help you reach your job and career goals with one-on-one support, counseling, and training.",
      "",
      ["Veteran Readiness and Employment programs"],
      [
        "Veteran Readines and Employment programs",
        "Veteran Readynes and Emplooyment programs",
        "Vetern Readiness and Employment programs"
      ],
      [
        "job training",
        "Veteran readiness",
        "career training",
        "employment services",
        "VRE",
        "chapter 31",
        "voc rehab",
        "vocational rehab and employment",
        "VR&E",
        "employment training"
      ]
    ],
    [
      "Patient advocates",
      null,
      [],
      "patientAdvocates",
      "Social programs and services",
      false,
      false,
      true,
      false,
      141,
      "VA wants to make sure that you get the best possible care. If you need help finding care or getting problems resolved, please contact a patient advocate.",
      "Please contact our patient advocates if you have any compliments, complaints, or concerns.",
      ["patient advocates"],
      [
        "patint advocates",
        "petient advocates",
        "patien advocates",
        "patint advcates"
      ],
      [
        "patient support",
        "advocate services",
        "advocacy assistance",
        "patient rights help",
        "complaint",
        "concern"
      ]
    ],
    [
      "Pharmacy",
      "Prescriptions, Rx, medications, pharmacist consultation",
      [],
      "pharmacy",
      "Primary care",
      false,
      false,
      true,
      false,
      141,
      "Our specialists provide a full range of services to help you get and understand your prescription medicines and supplies. You can refill VA prescriptions online, by phone or by mail.",
      "Our specialists provide a full range of services to help you get and understand your prescription medicines and supplies. You can refill TRICARE prescriptions online, by phone, or by mail.",
      ["pharmacies"],
      ["pharmcy", "pharamcy", "pharmasy", "pharamacy"],
      [
        "pharmacist",
        "medication management",
        "prescription services",
        "Rx",
        "script",
        "med",
        "medicine"
      ]
    ],
    [
      "Primary care",
      "Family and internal medicine",
      [],
      "primaryCare",
      "Primary care",
      null,
      null,
      true,
      null,
      140,
      "Your VA primary care provider will work closely with you to plan for all the care you need to stay healthy and well throughout your life, including immunizations and vaccinations. They will also work with family members or caregivers who support you.",
      "",
      ["primary cares"],
      ["primaryy care", "priimary care", "privary care", "primry care"],
      [
        "primary doctor",
        "general health care",
        "family medicine",
        "initial care",
        "PCP",
        "general doctor"
      ]
    ],
    [
      "Caregiver support",
      null,
      [],
      "caregiverSupport",
      "Social programs and services",
      false,
      false,
      true,
      false,
      140,
      "If you are caring for a Veteran with serious illness or disabilities, we can help you support them and take care of yourself. You may qualify for services like training, counseling or respite care when you need a break.",
      "If you're caring for someone with serious illness or disabilities, we can help you both. You may qualify for services like training, counseling, or respite care for when you need a break.",
      ["caregiver supports"],
      [
        "caregver support",
        "caregver suport",
        "caregier support",
        "caretiver support"
      ],
      [
        "caregiving help",
        "care support",
        "family caregiver assistance",
        "respite care",
        "CSP",
        "caregiver support"
      ]
    ],
    [
      "COVID-19 vaccines",
      null,
      ["coronavirus", "COVID-19"],
      "covid19Vaccine",
      "Specialty care",
      false,
      false,
      true,
      false,
      140,
      "We offer COVID-19 vaccines to all Veterans enrolled in VA health care. This includes Veterans who live or travel outside of the U.S. and are eligible for the VA Foreign Medical Program.",
      "We offer COVID-19 vaccines to TRICARE enrollees and DoD employees. ",
      ["COVID-19 vaccines"],
      [
        "COVID-19 vccines",
        "COVD-19 vaccines",
        "COVDI-19 vaccines",
        "COVID19 vacines"
      ],
      ["COVID vaccine", "COVID-19 shot", "coronavirus vaccine", "vaccination"]
    ],
    [
      "Laboratory and pathology",
      "Blood draw and clinical testing",
      [],
      "laboratory",
      "Specialty care",
      false,
      false,
      true,
      false,
      132,
      "We offer blood tests and other advanced testing services to help you and your VA health care team monitor your health, find and understand any health problems and make informed treatment decisions.",
      "We offer blood tests and other advanced testing services. Our tests help you and your TRICARE health care team monitor your health, find and understand any health problems, and make informed treatment decisions.",
      ["laboratory", "labs", "pathologies"],
      [
        "labratory and pathology",
        "labortory and pathology",
        "labratory and pathlogy",
        "labatory and pathology"
      ],
      [
        "lab tests",
        "pathologist",
        "clinical testing",
        "diagnostic laboratory",
        "blood draw"
      ]
    ],
    [
      "Audiology",
      "Hearing and balance",
      ["tinnitus", "vertigo", "hearing loss", "vestibular conditions"],
      "audiology",
      "Specialty care",
      false,
      false,
      true,
      false,
      130,
      "We diagnose and treat conditions affecting your hearing or balance, including hearing loss, tinnitus (noise or ringing in the ears) and dizziness.",
      "",
      ["audiologies", "hearing aids"],
      ["audiolgy", "audioligy", "audiolodgy", "audoilogy"],
      [
        "audiologist",
        "hearing care",
        "auditory health",
        "hearing specialist",
        "hearing aid"
      ]
    ],
    [
      "Social work",
      null,
      [],
      "socialWork",
      "Social programs and services",
      false,
      false,
      true,
      false,
      122,
      "Social workers are here to help Veterans, families and caregivers with almost any need, from help with finances or housing to questions about treatment to just feeling overwhelmed. We are here for you.",
      "Social workers are here to help you. Whether you need help with finances or housing, have questions about treatment, or feel overwhelmed and want to talk, we're here for you.",
      ["social works"],
      ["soial work", "socal work", "socil work", "sicial work"],
      [
        "social worker",
        "social services",
        "community support",
        "case work",
        "case management"
      ]
    ],
    [
      "Rehabilitation and extended care",
      null,
      [],
      "rehabilitation",
      "Specialty care",
      false,
      false,
      true,
      false,
      120,
      "We provide medical care and rehabilitation services to Veterans in our Community Living Center and in their homes. Services include home-based primary care, medical foster home support, and hospice and palliative care.",
      "We can provide medical care and rehabilitation services in your home and in our Community Living Center. We offer home-based primary care, medical foster home support, hospice, and palliative care.",
      ["rehabilitation and extended cares"],
      [
        "rehabiliation and exended care",
        "rehbilitation and extnded care",
        "rehabilitation nd extended care",
        "rehabilitation and extendet care"
      ],
      [
        "extended care",
        "rehab services",
        "long-term care",
        "rehabilitation services",
        "nursing home",
        "residential setting"
      ]
    ],
    [
      "Optometry",
      "Eye and vision care",
      [
        "General eye health",
        "low vision",
        "cataracts",
        "diabetic retinopathy",
        "glaucoma",
        "macular degeneration"
      ],
      "optometry",
      "Specialty care",
      false,
      false,
      true,
      false,
      118,
      "Our optometrists offer you comprehensive eye exams, preventive vision care, and treatment for conditions like diabetic retinopathy, glaucoma, and macular degeneration. We provide prescriptions for eyeglasses and other assistive devices. We also provide low-vision rehab services for Veterans with vision loss or brain injuries.",
      "",
      ["optometries"],
      ["optmetry", "optomtery", "optomertry", "optomitry"],
      [
        "optometrist",
        "eyesight care",
        "vision correction",
        "eye exams",
        "eye doctor",
        "glasses",
        "low vision",
        "contact lenses"
      ]
    ],
    [
      "Podiatry",
      "Foot, ankle and lower extremities",
      [
        "arthritis",
        "bunions",
        "diabetic foot care",
        "foot deformities",
        "skin conditions",
        "nail conditions"
      ],
      "podiatry",
      "Specialty care",
      false,
      false,
      true,
      false,
      117,
      "Our podiatry specialists evaluate and treat a wide range of injuries, diseases and disorders that affect your feet and ankles from ingrown toenails to inflammation to diabetic foot ulcers.",
      "",
      ["podiatries"],
      ["podiatry", "nail conditions", "poditry", "poditery", "poidatry"],
      [
        "foot care",
        "podiatrist",
        "lower limb care",
        "podiatric medicine",
        "ingrown nail",
        "ingrown toenail"
      ]
    ],
    [
      "Radiology",
      "Imaging",
      [],
      "radiology",
      "Specialty care",
      null,
      null,
      true,
      null,
      116,
      "We use imaging to help screen for, diagnose, and treat illness and injury. We provide X-rays and other imaging technologies.",
      "",
      ["radiologies"],
      ["radilogy", "radiolgy", "radiolagy", "radilogy"],
      [
        "radiologist",
        "imaging care",
        "diagnostic radiology",
        "medical imaging",
        "x-ray"
      ]
    ],
    [
      "Dental/oral surgery",
      "Mouth, teeth, gum, and oral care",
      [
        "teeth cleaning",
        "fillings",
        "restorations",
        "root canal",
        "bridges",
        "dental implants",
        "dentures"
      ],
      "dental",
      "Specialty care",
      false,
      false,
      true,
      false,
      115,
      "If you're eligible for VA dental care, we provide dental screenings, cleanings, X-rays and fillings. We also provide specialty dental procedures like root canal, restorations and dentures.",
      "We offer dental screenings, cleanings, X-rays, and fillings. We also provide specialty dental procedures like root canals, restorations, and dentures.",
      ["dental surgeries", "oral surgeries", "teeth"],
      [
        "dental/orl surgery",
        "dntal/oral surgry",
        "dental/ral surgery",
        "dental/oral surgry"
      ],
      [
        "dental care",
        "oral surgery",
        "dental treatment",
        "oral health",
        "tooth",
        "dentist"
      ]
    ],
    [
      "Nutrition, food, and dietary care",
      null,
      [],
      "nutrition",
      "Specialty care",
      false,
      false,
      true,
      false,
      115,
      "Our nutrition experts work closely with you and your care team to help make sure you're getting the nutrition you need to get and stay as healthy as possible.",
      "",
      ["nutrition", "foods", "and dietary cares"],
      [
        "nutrition",
        "food",
        "ana dietary care",
        "nutrtition",
        "food",
        "ad dietary care",
        "nutristion",
        "fod",
        "and dietary care",
        "nuttrition",
        "food",
        "dn dietary care"
      ],
      [
        "dietary advice",
        "nutrition help",
        "food planning",
        "dietitian services",
        "diet",
        "registered dietitian",
        "nutritionist",
        "registered dietitian nutritionist",
        "dietetic",
        "meal",
        "RD",
        "RDN"
      ]
    ],
    [
      "Cardiology",
      "Heart and circulation",
      [
        "heart disease",
        "high blood pressure",
        "heart rhythm disorders",
        "angina",
        "vascular diseases"
      ],
      "cardiology",
      "Specialty care",
      false,
      false,
      true,
      false,
      112,
      "Our cardiology specialists offer advanced treatment and care for conditions affecting your heart and blood vessels, including heart disease, stroke, heart rhythm disorders and high blood pressure.",
      "",
      ["cardiologies"],
      ["cardilogy", "cardiolgy", "cardiologi", "cadiology"],
      [
        "cardiologist",
        "heart care",
        "cardiovascular health",
        "cardiac specialist",
        "arrhythmia",
        "a fib",
        "atrial fib",
        "atrial fibrillation",
        "heart attack",
        "high cholesterol"
      ]
    ],
    [
      "Emergency care",
      "Emergency department",
      [],
      "emergencyCare",
      "Primary care",
      false,
      false,
      true,
      false,
      109,
      "In an emergency, call 911 or go to the nearest VA or non-VA emergency department. We provide immediate treatment for serious, life-threatening health emergencies such as severe chest pain, seizures, heavy uncontrollable bleeding or moderate to severe burns.",
      "",
      ["emergency cares"],
      ["emrgency care", "emrgancy care", "emergancy care", "emerjency care"],
      ["urgent care", "ER", "emergency services", "emergency room"]
    ],
    [
      "Physical therapy, occupational therapy and kinesiotherapy",
      "PT, OT, KT",
      [],
      "physicalTherapy",
      "Specialty care",
      null,
      null,
      true,
      null,
      98,
      "Physical therapy, occupational therapy and kinesiotherapy can help restore movement and function if you have been disabled by injury or disease.",
      "",
      ["physical therapies", "occupational therapies", "and kinesiotherapies"],
      [
        "pysical therapy",
        "ocupational therapy",
        "nnd kinesiotherapy",
        "physical therpy",
        "ccupational therapy",
        "and kinesotherapy",
        "pysicall therapy",
        "occupational teraphy",
        "and kinesiotherapy"
      ],
      [
        "physiotherapy",
        "occupational therapy",
        "movement therapy",
        "functional therapy",
        "PT",
        "OT",
        "KT"
      ]
    ],
    [
      "Prosthetics and rehabilitation",
      "Prosthetics, orthotics and medical equipment",
      [],
      "prosthetics",
      "Specialty care",
      null,
      null,
      true,
      null,
      96,
      "We provide and help you use medical aids, hearing aids, state-of-the-art adaptive home equipment and other equipment to help you preserve and increase your mobility and independence.",
      "",
      ["prosthetics and rehabilitations"],
      [
        "protshetics and rehabilitation",
        "prostetics and rrehabilitation",
        "prosthetcs and rehabilitation",
        "prosthetics an rehabilitation"
      ],
      [
        "prosthetic care",
        "rehab equipment",
        "orthotic services",
        "limb replacement"
      ]
    ],
    [
      "Urology",
      "Male and female urinary tract and male reproductive system",
      ["prostate cancer", "erectile dysfunction", "urinary disorders"],
      "urology",
      "Specialty care",
      false,
      false,
      true,
      false,
      96,
      "We offer understanding and advanced care and treatment to Veterans with conditions that affect the male urinary and reproductive systems and the female urinary system.",
      "If you have a condition that affects your urinary system, or you're a male with a condition that affects your reproductive system, we offer understanding and advanced care and treatment. ",
      ["urologies"],
      ["urolgy", "uroligy", "urlogy", "yorology"],
      [
        "urologist",
        "urinary care",
        "urologic health",
        "reproductive health care",
        "BPH",
        "benign prostatic hyperplasia",
        "ED",
        "impotence",
        "urine",
        "incontinence",
        "kidney stones",
        "bladder",
        "PSA"
      ]
    ],
    [
      "My HealtheVet coordinator",
      null,
      [],
      "myHealtheVetCoordinator",
      "Other services",
      false,
      false,
      true,
      false,
      94,
      "Your My HealtheVet coordinator can help you start using the VA online portal to manage your appointments and records, refill prescriptions, view your lab and test results and communicate with your health care team.",
      "",
      ["My HealtheVet coordinators"],
      [
        "My HealtheVet cordinator",
        "My HaltheVet coordintor",
        "My HelatheVet coordinator",
        "My HealthVet coordnator"
      ],
      [
        "health coordinator",
        "My HealtheVet help",
        "patient portal support",
        "health record assistance"
      ]
    ],
    [
      "Gastroenterology",
      "Digestive care, GI",
      [
        "acid reflux",
        "fatty liver",
        "irritable bowel syndrome",
        "inflammatory bowel disease",
        "diarrhea",
        "cancer screening"
      ],
      "gastroenterology",
      "Specialty care",
      false,
      false,
      true,
      false,
      94,
      "Our gastrointestinal (GI) specialists offer treatment and procedures (endoscopy, colonoscopy) for conditions affecting your GI tract, gallbladder, liver and pancreas, including acid reflux, inflammatory bowel disease (Crohn's disease and ulcerative colitis), fatty liver disease, cirrhosis, irritable bowel syndrome, and pancreatitis.",
      "",
      ["gastroenterologies"],
      [
        "gastroentrology",
        "gastroeenterology",
        "gastroenterolgy",
        "gastroenterolog"
      ],
      [
        "gastroenterologist",
        "GI care",
        "digestive health",
        "stomach specialist",
        "Crohn's disease",
        "IBS",
        "GERD",
        "IBD",
        "reflux"
      ]
    ],
    [
      "Dermatology",
      "Skin conditions and diseases",
      [
        "psoriasis",
        "eczema",
        "skin cancer",
        "acne",
        "rosacea",
        "allergic skin diseases",
        "ulcers"
      ],
      "dermatology",
      "Specialty care",
      false,
      false,
      true,
      false,
      93,
      "Our dermatologists offer expert treatment for a range of conditions that affect your skin, hair and nails from acne to psoriasis to skin cancer. We also offer skin cancer screening and education.",
      "",
      ["dermatologies"],
      ["dermatolgy", "dermotology", "dermatoligy", "dermatalogy"],
      [
        "dermatologist",
        "skin care",
        "dermatological treatment",
        "skin specialist",
        "skin doctor"
      ]
    ],
    [
      "Neurology",
      "Brain, spine, and nervous system",
      [
        "cognitive disorders",
        "epilepsy",
        "headache",
        "motor neuron diseases",
        "movement disorders",
        "multiple sclerosis",
        "stroke"
      ],
      "neurology",
      "Specialty care",
      false,
      false,
      true,
      false,
      93,
      "Our specialists evaluate and treat conditions and diseases of the brain, spine, and nervous system, including headache, stroke, Alzheimer's disease, epilepsy, Parkinson's disease and other conditions.",
      "",
      ["neurologies"],
      ["nurology", "nerurology", "neuroligy", "nuerology"],
      [
        "neurologist",
        "nervous system care",
        "brain specialist",
        "neurohealth",
        "migraine",
        "MS",
        "multiple sclerosis",
        "Parkinson's",
        "Parkinsons",
        "Parkinson's disease",
        "ALS",
        "concussion",
        "Alzheimer's",
        "Alzheimers",
        "Alzheimer's disease"
      ]
    ],
    [
      "Ophthalmology",
      "Eye and vision care",
      ["cataracts", "glaucoma", "macular degeneration", "diabetic eye disease"],
      "ophthalmology",
      "Specialty care",
      false,
      false,
      true,
      false,
      92,
      "Our ophthalmology specialists diagnose and provide medical and surgical care for conditions that affect your eyes like cataracts, glaucoma, macular degeneration and diabetic retinopathy.",
      "",
      ["ophthalmologies"],
      ["ophthamology", "opthalmology", "opthalmolgy", "opthalmalogy"],
      [
        "ophthalmologist",
        "eye care",
        "vision health",
        "ocular specialist",
        "eye doctor"
      ]
    ],
    [
      "Surgery",
      null,
      [],
      "surgery",
      "Specialty care",
      null,
      null,
      true,
      null,
      91,
      "If you are having surgery, we make sure that your procedure and follow-up care are safe and high-quality.",
      "",
      ["surgeries"],
      ["surgry", "surger", "surgury", "surjery"],
      ["surgical care", "operation", "surgical procedure", "operative care"]
    ],
    [
      "MOVE! weight management",
      null,
      ["overweight", "obesity", "diabetes", "high blood pressure"],
      "weightManagement",
      "Specialty care",
      false,
      false,
      true,
      false,
      91,
      "We offer easy-to-follow weight management plans backed by the latest science. Our experts can help you reduce health risks, prevent or reverse some diseases and live a better and even longer life.",
      "",
      ["MOVE! weight managements"],
      [
        "MOVE weight managment",
        "MOVE weight managementt",
        "MOEV! weight management",
        "MOVE! wight managment"
      ],
      [
        "weight management",
        "MOVE program",
        "weight control",
        "obesity intervention",
        "MOVE!",
        "pre-diabetes",
        "weight loss"
      ]
    ],
    [
      "Palliative and hospice care",
      "Serious illness, hospice and end-of-life care",
      [],
      "hospice",
      "Specialty care",
      false,
      false,
      true,
      false,
      91,
      "Palliative care focuses on comfort, quality of life and reducing suffering. Hospice care is a type of palliative care offered to patients with life-threatening illness under certain conditions.",
      "",
      ["palliative and hospice cares"],
      [
        "pallitve and hospice care",
        "pallative and hospice car",
        "pallative and hospise care",
        "palliative aand hospice care"
      ],
      [
        "end-of-life care",
        "palliative care",
        "comfort care",
        "serious illness care",
        "hospice"
      ]
    ],
    [
      "Intimate partner violence support",
      "Domestic violence, abuse",
      [],
      "domesticAbuseSupport",
      "Social programs and services",
      true,
      false,
      true,
      false,
      90,
      "If you feel that you or a loved one are in or may be in a potentially abusive or violent relationship, we can help.",
      "",
      ["intimate partner violences"],
      [
        "intimate ppartner violence suport",
        "intmate partner voilence support",
        "intimte parter violence support",
        "intimatte partener violence support"
      ],
      [
        "IPV support",
        "domestic violence help",
        "abuse intervention",
        "partner abuse support",
        "hospitalist"
      ]
    ],
    [
      "Blind and low vision rehabilitation",
      null,
      [
        "macular degeneration",
        "diabetic eye disease",
        "glaucoma",
        "corneal diseases",
        "retinitis pigmentosa",
        "uveitis",
        "stroke",
        "injury-related vision loss"
      ],
      "vision",
      "Specialty care",
      false,
      false,
      true,
      false,
      90,
      "We help you get back the confidence and skills you need to lead an independent, fulfilling life after vision loss.",
      "",
      ["blind and low visions rehabilitations"],
      [
        "bliind and low vison care",
        "blind and low vission care",
        "blynd and low vision rehabilitation",
        "blined and low vision reabilitation"
      ],
      [
        "low vision care",
        "blind rehabilitation",
        "visual impairment support",
        "vision therapy",
        "blind rehab",
        "glasses",
        "blind training",
        "low vision training"
      ]
    ],
    [
      "Pulmonary medicine",
      "Lungs and breathing",
      [
        "tuberculosis",
        "respiratory conditions",
        "sleep apnea",
        "sleep problems"
      ],
      "pulmonaryMedicine",
      "Specialty care",
      null,
      null,
      true,
      null,
      87,
      "Our pulmonary medicine team treats diseases and conditions that affect the lungs and breathing, including asthma, tuberculosis, chronic obstructive pulmonary disease, acute respiratory distress syndrome and sleep apnea.",
      "",
      ["pulmonary medicines"],
      [
        "pulmonary medcine",
        "pulmoncrary medicine",
        "palmonary medicine",
        "pulmonayr medicine"
      ],
      [
        "pulmonologist",
        "lung care",
        "respiratory health",
        "breathing specialist",
        "COPD",
        "chronic obstructive pulmonary disease",
        "emphaseema",
        "asthma",
        "bronchitis"
      ]
    ],
    [
      "Orthopedics",
      "Bones, muscles and joints",
      [
        "arthritis",
        "musculoskeletal disorders",
        "tendon repair",
        "ligament repair",
        "joint replacement"
      ],
      "orthopedics",
      "Specialty care",
      false,
      false,
      true,
      false,
      86,
      "Our orthopedists offer advanced care and treatment for issues related to muscles, bones and joints, including arthritis, disorders of the muscles and bones, tendon and ligament repair and joint replacement.",
      "",
      ["orthopedics", "joints", "muscles"],
      ["orthpedics", "orthopdics", "orthopetics", "orthopaedics"],
      [
        "orthopedic",
        "bone care",
        "musculoskeletal health",
        "joint specialist",
        "ortho",
        "muscle"
      ]
    ],
    [
      "Geriatrics",
      "Older adult care, senior care",
      [
        "memory problems",
        "sleep problems",
        "falls",
        "bone loss",
        "weight loss"
      ],
      "geriatrics",
      "Primary care",
      false,
      false,
      true,
      false,
      81,
      "As you age, we offer a range of medical and support services to help you stay as healthy, active and independent as possible. We also offer help to family members and caregivers who may support you.",
      "",
      ["geriatrics"],
      ["geriatrcs", "geriatricts", "geriatric care", "grdiatrics"],
      [
        "geriatrician",
        "senior care",
        "elderly health",
        "aging specialist",
        "elder care",
        "older adult care",
        "dementia",
        "Alzheimers",
        "Alzheimer's"
      ]
    ],
    [
      "Spinal cord injuries and disorders",
      null,
      [],
      "spinalInjury",
      "Specialty care",
      null,
      null,
      true,
      null,
      79,
      "If you have a spinal cord injury or disorder, our specialists provide coordinated care throughout your life. We work to help you achieve your goals for independence, productivity and quality of life.",
      "",
      ["spinal cord injuries and disorders"],
      [
        "spinl cord injurys and disorder",
        "spina cord injuries and rn disorders",
        "spinall cord injuriesn and disorders"
      ],
      [
        "spinal care",
        "SCI support",
        "spinal rehabilitation",
        "spinal cord injury treatment",
        "paraplegia",
        "quadriplegia",
        "para",
        "quad",
        "tetraplegia",
        "paraplegic",
        "quadriplegic"
      ]
    ],
    [
      "Recreation and creative arts therapy",
      null,
      [],
      "recreationTherapy",
      "Social programs and services",
      true,
      null,
      true,
      null,
      78,
      "We offer a wide range of activities (arts and crafts, games, sports, exercise) that we can adapt to your needs.",
      "",
      ["recreation and creative arts therapies"],
      [
        "recreaion and creative arts therapy",
        "recreation and cretive arts therapy",
        "recreational and creative arst therapy",
        "recaeration and creative arts therapy"
      ],
      [
        "art therapy",
        "recreational therapy",
        "creative therapy",
        "therapeutic activities",
        "rec therapy"
      ]
    ],
    [
      "Hematology/oncology",
      "Blood disorders and medical oncology",
      [],
      "hematology",
      "Specialty care",
      false,
      false,
      true,
      false,
      75,
      "If you have a diagnosis of anemia, lymphoma, leukemia or another blood cancer or disorder, we support you with expert care and treatment.",
      "",
      ["hematologies/oncologies"],
      [
        "hemotology/ooncology",
        "hematolgy/oncolgy",
        "hematoly/oncolgy",
        "hemotology/oncology"
      ],
      ["hematology", "oncology", "blood specialist", "cancer treatment"]
    ],
    [
      "Pain management",
      null,
      [],
      "painManagement",
      "Specialty care",
      false,
      false,
      true,
      false,
      75,
      "If you are in pain, we work with you and your health care team to find the best way to treat and manage it.",
      "",
      ["pain managements"],
      [
        "pain managment",
        "pane management",
        "pain managemant",
        "pain mangement"
      ],
      [
        "pain relief",
        "pain control",
        "chronic pain treatment",
        "pain intervention",
        "opioid",
        "analgesic"
      ]
    ],
    [
      "Physical medicine and rehabilitation",
      null,
      [
        "pain",
        "stroke",
        "brain injury",
        "neuromuscular disorders",
        "musculoskeletal problems",
        "sports injuries",
        "spinal cord injuries"
      ],
      "physicalMedicine",
      "Specialty care",
      false,
      false,
      true,
      false,
      75,
      "If you're living with a traumatic brain injury, amputation or other disability, our specialists offer support to help you improve your independence and quality of life, manage pain and stay healthy.",
      "",
      ["physical medicines and rehabilitations"],
      [
        "phsical medicine and rehabilitation",
        "physical medcine and rehabilitation",
        "physical meidicine and rehabilitation",
        "physical medecine and rehbillitation"
      ],
      [
        "rehab medicine",
        "physiatry",
        "physical rehabilitation",
        "functional recovery"
      ]
    ],
    [
      "Smoking and tobacco cessation",
      "Quit smoking",
      [],
      "smoking",
      "Specialty care",
      null,
      null,
      true,
      null,
      72,
      "If you are trying to quit smoking or want to stop using tobacco, we can help you with support, resources and programs.",
      "",
      ["smoking and tobacco cessations"],
      [
        "smoknig and tobacco cessation",
        "smoking and tobacoc cessation",
        "smmoking and tobacco cessation",
        "smoking adn tobacco cessation"
      ],
      [
        "tobacco cessation",
        "smoking cessation",
        "quit smoking support",
        "nicotine addiction treatment",
        "vaping",
        "Quit VET",
        "smokeless tobacco"
      ]
    ],
    [
      "Nephrology",
      "Kidney and renal care",
      ["Dialysis", "kidney disease", "high blood pressure", "hypertension"],
      "nephrology",
      "Specialty care",
      false,
      false,
      true,
      false,
      70,
      "Our specialists offer you advanced care for kidney-related diseases like chronic kidney disease, high blood pressure and fluid and electrolyte problems. We also provide dialysis and related support.",
      "",
      ["nephrologies", "kidneys"],
      ["nephrology", "nephorolgy", "nepholgy", "nephoroligy"],
      ["nephrologist", "renal care", "kidney specialist", "dialysis management"]
    ],
    [
      "Disability compensation",
      null,
      [],
      "DisabilityClaimAssistance",
      null,
      false,
      true,
      false,
      false,
      69,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Toxic exposure screening",
      "Military exposure screening, war-related exposure screening",
      [
        "War-related exposure",
        "open burn pit exposure",
        "airborne hazards exposure",
        "Gulf War-related exposure",
        "Gulf War Illness",
        "Agent Orange exposure",
        "radiation exposure",
        "Camp Lejeune contaminated water exposure"
      ],
      "toxicExposureScreening",
      "Specialty care",
      false,
      false,
      true,
      false,
      63,
      "We provide a quick screening to identify toxins you may have come in contact with during your military service. The screening takes 5 to 10 minutes. During the screening, we'll ask you questions and document your responses in your medical record. Your answers will inform your VA health care team of any possible exposures. We'll also connect you to more resources if you have any concerns.",
      "We provide a quick screening to identify toxins you may have come in contact with during your military service. The screening takes 5 to 10 minutes. During the screening, we'll ask you questions and document your responses in your medical record. Your answers will inform your health care team of any possible exposures. We'll also connect you to more resources if you have any concerns.",
      ["toxic exposure screenings"],
      [
        "toxic esposure screening",
        "toixc exposure screening",
        "tocix exposure screening",
        "toxic eposure screening"
      ],
      [
        "toxic screening",
        "exposure test",
        "hazardous exposure screening",
        "toxicology exams",
        "environmental health registry",
        "depleted uranium",
        "uranium",
        "Gulf War",
        "ionizing radiation",
        "toxic embedded fragments",
        "embedded fragments"
      ]
    ],
    [
      "Diabetes care",
      null,
      ["Diabetes type 1", "Diabetes type 2"],
      "diabetic",
      "Specialty care",
      false,
      false,
      true,
      false,
      61,
      "We offer treatment for type 1 and 2 diabetes. We work with you, your family and caregivers to help you live a healthier life through treatment, monitoring, diet and education.",
      "",
      ["diabetes cares"],
      ["diabeetes care", "diebetes care", "diabetas care", "diabetees care"],
      [
        "diabetic care",
        "sugar disease care",
        "diabetes management",
        "endocrinology",
        "glucose",
        "gestational diabetes"
      ]
    ],
    [
      "Sleep medicine",
      "CPAP therapy",
      [
        "insomnia",
        "narcolepsy",
        "restless legs syndrome",
        "sleep apnea",
        "sleepwalking"
      ],
      "sleepMedicine",
      "Specialty care",
      null,
      null,
      true,
      null,
      60,
      "The sleep medicine service diagnoses and treats your sleep problems, including trouble sleeping, breathing difficulties while sleeping, snoring, teeth grinding and jaw clenching.",
      "",
      ["sleep medicines"],
      ["slep medicine", "steep medicine", "sleap medicine", "sleep medcine"],
      [
        "sleep care",
        "sleep specialist",
        "sleep disorder treatment",
        "sleep therapy",
        "OSA"
      ]
    ],
    [
      "Gynecology",
      "Reproductive and maternal health, women's health",
      [],
      "gynecology",
      "Primary care",
      false,
      false,
      true,
      false,
      60,
      "Our specialists offer reproductive health care services for women Veterans, including contraception, pregnancy care and fertility treatment.",
      "Our specialists offer reproductive health care services, including contraception, pregnancy care, and fertility treatment.",
      ["gynecologies"],
      ["gynecology", "gynecolgy", "ginecology", "gynecolog"],
      [
        "gyn",
        "OB/GYN",
        "women's health",
        "reproductive care",
        "OB",
        "women health",
        "birth control"
      ]
    ],
    [
      "Otolaryngology",
      "Ear, nose and throat; head and neck surgery",
      [
        "balance issues",
        "sinusitis",
        "difficulty swallowing",
        "obstructive sleep apnea",
        "head tumors",
        "neck tumors"
      ],
      "otolaryngology",
      "Specialty care",
      false,
      false,
      true,
      false,
      60,
      "We provide a full range of care for Veterans who have problems that affect their ears, sinuses, adenoids, tonsils and thyroid.",
      "If you have problems that affect your ears, sinuses, adenoids, tonsils, and thyroid, we can help with our full range of care.",
      ["otolaryngologies"],
      ["otolarygology", "otolarygolgy", "otolaryngolojy", "otlaryngology"],
      [
        "ENT care",
        "head and neck surgery",
        "otolaryngologist",
        "ear nose throat doctor"
      ]
    ],
    [
      "Psychiatry",
      null,
      [],
      "psychiatry",
      "Mental health care",
      null,
      null,
      true,
      null,
      59,
      "If you're struggling with a mental health problem or just need to talk with someone we can help. We offer treatment and support such as therapy, alternative treatments  and medications when needed.",
      "",
      ["psychiatries"],
      ["psychatry", "psyciatry", "psychiatric", "psichiatry"],
      [
        "psychiatric",
        "mental health care",
        "psychiatric services",
        "psychiatric treatment"
      ]
    ],
    [
      "Benefit letters and decision letters",
      null,
      [],
      "BenefitLetters",
      null,
      false,
      true,
      false,
      false,
      57,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Endocrinology",
      "Hormones",
      [
        "diabetes",
        "thyroid conditions",
        "parathyroid conditions",
        "endocrine conditions"
      ],
      "endocrinology",
      "Specialty care",
      false,
      false,
      true,
      false,
      56,
      "We provide caring, expert treatment for diabetes and disorders of the endocrine, hormonal, glandular and metabolic systems.",
      "",
      ["endocrinologies"],
      ["endocrinolgy", "endocronology", "endocrinoligy", "endocrinlogy"],
      [
        "endocrinologist",
        "hormone care",
        "endocrine specialist",
        "metabolic disorders",
        "hypothyroidism",
        "hyperthyroidism",
        "thyroid"
      ]
    ],
    [
      "Psychology",
      null,
      [],
      "psychology",
      "Mental health care",
      null,
      null,
      true,
      null,
      55,
      "If you're struggling with a mental health problem or just need to talk with someone we can help. We offer treatment and support such as therapy, alternative treatments and medications when needed.",
      "",
      ["psychologies"],
      ["pscychology", "psycholgy", "physchology", "psychollogy"],
      [
        "psychological care",
        "therapy",
        "mental health counseling",
        "psychotherapy",
        "counselor",
        "talk therapy"
      ]
    ],
    [
      "Urgent care",
      "Walk-in care",
      ["sore throat", "pink eye", "flu", "sprains", "strains"],
      "urgentCare",
      "Primary care",
      false,
      false,
      true,
      false,
      55,
      "We provide immediate, walk-in care for minor injuries and non-emergency illnesses that are not life-threatening but need early attention.",
      "",
      ["urgent cares"],
      ["urgunt care", "urent care", "urgent car", "urgnt care"],
      ["walk-in clinics", "urgent clinic", "immediate care", "emergency clinic"]
    ],
    [
      "Travel reimbursement",
      null,
      [],
      "travelReimbursement",
      "Other services",
      false,
      false,
      true,
      false,
      54,
      "If you have to travel far for care, we may be able to reimburse (repay) you for travel expenses. We can also help arrange transportation for getting to and from your VA appointment.",
      "If you have to travel far for care, we may be able to reimburse (repay) you for travel expenses. We can also help arrange transportation for getting to and from your TRICARE appointment.",
      ["travel reimbursements"],
      [
        "travel reimbursment",
        "travl reimbursement",
        "travel reimbursementt",
        "travel reinbursement"
      ],
      [
        "travel costs",
        "Veteran travel reimbursement",
        "travel payments",
        "travel support",
        "travel claim",
        "mileage claim",
        "travel expense",
        "travel pay"
      ]
    ],
    [
      "Workshops and classes",
      null,
      [],
      "workshops",
      null,
      true,
      false,
      false,
      false,
      54,
      "We offer workshops and classes if you want to connect with other Veterans but don't want a group counseling setting.",
      "We offer workshops and classes if you want to connect with other Veterans and military community members but don't want a group counseling setting.",
      [],
      [],
      []
    ],
    [
      "Rheumatology",
      "Arthritis and joint conditions",
      ["arthritis", "Crohn's disease", "gout", "lupus"],
      "rheumatology",
      "Specialty care",
      false,
      false,
      true,
      false,
      53,
      "Our team cares for and treats Veterans with joint and autoimmune conditions.",
      "If you have joint or autoimmune conditions, we offer care and treatment.",
      ["rheumatologies"],
      ["rheumatolgy", "rheumatolog", "rhimatology", "reumatology"],
      [
        "rheumatologist",
        "joint care",
        "arthritis treatment",
        "autoimmune disease specialist",
        "ankylosing spondylitis"
      ]
    ],
    [
      "Infectious disease",
      "HIV/AIDS",
      [],
      "infectiousDisease",
      "Specialty care",
      false,
      false,
      true,
      false,
      51,
      "We evaluate and treat Veterans with infections including hepatitis, HIV/AIDS and tuberculosis.",
      "If you have an infection, we can help evaluate and treat it. We can help with hepatitis, HIV/AIDS, and tuberculosis. ",
      ["infectious diseases"],
      [
        "infectous disease",
        "infectius disase",
        "infctious disease",
        "infecious disease"
      ],
      [
        "infection care",
        "disease specialist",
        "infectious disease doctor",
        "pathogen treatment",
        "hiv prep",
        "sexually transmitted infections",
        "sexually transmitted diseases",
        "STD"
      ]
    ],
    [
      "Direct deposit information",
      null,
      [],
      "UpdatingDirectDepositInformation",
      null,
      false,
      true,
      false,
      false,
      50,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Advice nurse",
      null,
      [],
      "adviceNurse",
      "Primary care",
      false,
      false,
      true,
      false,
      49,
      "Talk with an advice nurse if you have questions about your care or for help in deciding whether you need an urgent or routine appointment.",
      "",
      ["advice nurses"],
      ["advic nurse", "advice nerse", "advoice nurse", "advie nurse"],
      [
        "advice nursing",
        "nurse consultation",
        "nurse advice line",
        "nursing hotline",
        "virtual nurse"
      ]
    ],
    [
      "Chiropractic",
      null,
      [],
      "chiropractic",
      "Specialty care",
      false,
      false,
      true,
      false,
      48,
      "Chiropractors work closely with your health care team to diagnose and manage muscle and joint conditions, including problems in the back, neck and other areas.",
      "",
      ["chiropractics"],
      ["chiroprctic", "chriopractic", "chiroprctc", "chirpractic"],
      [
        "chiropractor",
        "adjustment therapy",
        "spinal manipulation",
        "chiropractic care"
      ]
    ],
    [
      "Vascular surgery",
      "Arteries, veins and circulation",
      ["vascular conditions", "varicose veins"],
      "vascularSurgery",
      "Specialty care",
      null,
      null,
      true,
      null,
      46,
      "Our expert team diagnoses and treats diseases and conditions that affect arteries, veins and blood circulation.",
      "",
      ["vascular surgeries"],
      [
        "vascular sugery",
        "vascular sergury",
        "vascular surgary",
        "vacular surgery"
      ],
      [
        "vascular care",
        "vascular operations",
        "artery surgery",
        "vein surgery",
        "blood vessel surgery"
      ]
    ],
    [
      "Cancer care",
      null,
      [],
      "cancer",
      "Specialty care",
      false,
      false,
      true,
      false,
      44,
      "VA provides expert cancer diagnosis and care. We offer services to support you through treatment and beyond.",
      "We offer expert cancer diagnosis and care. We can support you through treatment and beyond.",
      ["cancer cares"],
      ["cancerr care", "cancar care", "caner care", "cacer care"],
      [
        "oncology",
        "cancer treatment",
        "radiation oncology",
        "chemotherapy",
        "chemo",
        "radiation"
      ]
    ],
    [
      "Military service records",
      null,
      [],
      "MilitaryRecords",
      null,
      false,
      true,
      false,
      false,
      44,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Registry exams",
      "Military exposures: Agent Orange, burn pit, Gulf War",
      [],
      "registryExams",
      "Social programs and services",
      null,
      null,
      true,
      null,
      41,
      "If you were exposed to toxic chemicals or other hazards during your military service, we offer you a free exam. This exam helps you identify potential health risks and helps us monitor issues so we can better serve you.",
      "",
      ["registry exams"],
      ["rgistry exams", "regstry exams", "registery exams", "refistry exams"],
      [
        "exposure exams",
        "registry tests",
        "medical registry exams",
        "military exposure exams"
      ]
    ],
    [
      "Plastic and reconstructive surgery",
      null,
      [],
      "plasticSurgery",
      "Specialty care",
      null,
      null,
      true,
      null,
      37,
      "Plastic and reconstructive surgery can restore function and appearance after damage from disease, burns, traumatic injuries, congenital and developmental conditions and other causes.",
      "",
      ["plastic and reconstructive surgeries"],
      [
        "platic and reconstructive surgery",
        "plastick and reconstructive surgery",
        "plstic and recunstructive surgery",
        "plastic and rekonstructive surgery"
      ],
      [
        "cosmetic surgery",
        "plastic reconstruction",
        "reconstructive surgery",
        "aesthetic surgery"
      ]
    ],
    [
      "Pre-discharge claims",
      null,
      [],
      "PreDischargeClaimAssistance",
      null,
      false,
      true,
      false,
      false,
      37,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Polytrauma and traumatic brain injury",
      "TBI and multiple traumas",
      [],
      "polytrauma",
      "Specialty care",
      false,
      false,
      true,
      false,
      36,
      "We provide a thoughtful, wide-ranging approach to treating Veterans who have injuries to multiple body systems caused by a single event.",
      "If you experienced an event that caused more than one injury to systems throughout your body, we can help. We offer a thoughtful and wide-ranging approach to our care. ",
      ["polytrauma and traumatic brain injuries"],
      [
        "polytraum and traumatic brain injury",
        "polytrauma and trraumatic brain injury",
        "polytrauma ans traumatic brian injury",
        "polytrauma and trumatic brain injury"
      ],
      [
        "multiple trauma care",
        "TBI help",
        "brain injury support",
        "polytrauma treatment"
      ]
    ],
    [
      "Anesthesia",
      null,
      [],
      "anesthesia",
      "Specialty care",
      false,
      false,
      true,
      false,
      36,
      "The anesthesia service works to keep you comfortable, safe and pain-free during surgical or screening procedures.",
      "",
      ["anesthesias"],
      ["anasthesia", "anestesia", "anethesia", "anaesthsia"],
      ["anesthetic", "anesthesia care", "sedation", "pain management"]
    ],
    [
      "Military sexual trauma-related claims",
      null,
      [],
      "MilitarySexualTraumaClaims",
      null,
      false,
      true,
      false,
      false,
      34,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Radiation oncology",
      null,
      [],
      "radiationOncology",
      "Specialty care",
      null,
      null,
      true,
      null,
      32,
      "The radiation oncology service works with your health care team to target cancer safely and precisely using radiation therapy.",
      "",
      ["radiation oncologies"],
      [
        "radition oncology",
        "radation oncology",
        "radition onconology",
        "reditation oncology"
      ],
      [
        "radiology",
        "cancer radiation",
        "radiation therapy",
        "oncological radiology"
      ]
    ],
    [
      "Burials and memorials",
      null,
      [],
      "BurialClaimAssistance",
      null,
      false,
      true,
      false,
      false,
      32,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Survivor compensation",
      null,
      [],
      "FamilyMemberClaimAssistance",
      null,
      false,
      true,
      false,
      false,
      32,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Wound care and ostomy",
      null,
      [],
      "wound",
      "Specialty care",
      false,
      false,
      true,
      false,
      31,
      "We provide thoughtful, compassionate diagnosis and treatment for Veterans with acute or chronic wounds or those who need ostomy care.",
      "If you have acute or chronic wounds, or you need ostomy care, we can help. We provide thoughtful and compassionate diagnosis and treatment.",
      ["wound cares and ostomies"],
      [
        "would care and ostomy",
        "would car and ostomy",
        "wound carre and ostomy",
        "wound cae and ostomy"
      ],
      [
        "wound management",
        "ostomy care",
        "ostomy support",
        "surgical wound care",
        "pressure injury",
        "pressure sore",
        "decubitus",
        "decub"
      ]
    ],
    [
      "Veterans Pension",
      null,
      [],
      "Pensions",
      null,
      false,
      true,
      false,
      false,
      31,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Amputation care",
      null,
      [],
      "amputation",
      "Specialty care",
      false,
      false,
      true,
      false,
      30,
      "If you face or have had an amputation, our team will support you with thoughtful, compassionate care.",
      "",
      ["amputation cares"],
      [
        "amputtion care",
        "ampuitation care",
        "amputation cear",
        "amputacion care"
      ],
      [
        "limb care",
        "amputee care",
        "prosthetic fitting",
        "post-amputation rehabilitation"
      ]
    ],
    [
      "Education benefits for family members",
      null,
      [],
      "FamilyEducationBenefits",
      null,
      false,
      true,
      false,
      false,
      29,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Critical care",
      null,
      [],
      "criticalCare",
      "Specialty care",
      false,
      false,
      true,
      false,
      28,
      "If you or a Veteran you care about has a life-threatening injury, infection, illness or breathing problem, we offer comprehensive care and constant monitoring in our intensive care units (ICUs).",
      "If you have a life-threatening injury, infection, illness, or breathing problem, we offer comprehensive care and constant monitoring in our intensive care units (ICUs).",
      ["critical cares"],
      ["crtical care", "critcal care", "criticle care", "crticl care"],
      ["intensive care", "ICU", "critical care medicine", "emergency care"]
    ],
    [
      "Transition assistance",
      null,
      [],
      "TransitionAssistance",
      null,
      false,
      true,
      false,
      false,
      28,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Thoracic surgery",
      "Chest/lung surgery",
      [
        "esophageal conditions",
        "lung conditions",
        "lung cancer",
        "mesothelioma"
      ],
      "thoracicSurgery",
      "Specialty care",
      false,
      false,
      true,
      false,
      28,
      "We perform chest surgery (also known as thoracic surgery) to treats conditions involving your chest, airway and esophagus.",
      "",
      ["thoracic surgeries"],
      [
        "thoracic surgury",
        "thoracic surgeryy",
        "thoracic surgary",
        "thoracicu surgery"
      ],
      [
        "thoracic operation",
        "chest surgery",
        "lung surgery",
        "esophageal surgery"
      ]
    ],
    [
      "Veterans Service Organizations (VSO)",
      null,
      [],
      "veteranServiceOrganizations",
      null,
      false,
      true,
      false,
      false,
      28,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Allergy, asthma and immunology",
      null,
      [],
      "allergy",
      "Specialty care",
      false,
      false,
      true,
      false,
      27,
      "We offer services and treatment for Veterans with allergies, asthma and other immune system conditions.",
      "If you have allergies, asthma, or other immune system conditions, we can help with our services and treatments.",
      ["allergy", "asthmas and immunologies"],
      ["allegy", "astma", "imunology", "alergy", "asthama and immunlogy"],
      [
        "allergist",
        "immunologist",
        "asthma care",
        "allergy treatment",
        "immune system specialist",
        "allergies",
        "allergic reaction"
      ]
    ],
    [
      "Education benefits for Veterans",
      null,
      [],
      "EducationClaimAssistance",
      null,
      false,
      true,
      false,
      false,
      26,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Complementary and integrative health",
      "Alternative medicine, acupuncture, yoga, and meditation",
      [],
      "complementaryHealth",
      "Primary care",
      false,
      false,
      true,
      false,
      25,
      "Complementary and integrative approaches like acupuncture, yoga, and meditation can improve mental health, help you manage pain, and promote wellness.",
      "",
      ["complementary and integrative healths"],
      [
        "complamentory and integrative helth",
        "complementry and integratve health",
        "complentry and intergrative health",
        "compliementary and integrative helath",
        "wholistic"
      ],
      [
        "holistic health",
        "integrative medicine",
        "alternative interventions",
        "complementary therapies"
      ]
    ],
    [
      "Careers and employment",
      null,
      [],
      "EducationAndCareerCounseling",
      null,
      false,
      true,
      false,
      false,
      24,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Neurosurgery",
      "Brain and spine",
      [],
      "neurosurgery",
      "Specialty care",
      false,
      false,
      true,
      false,
      23,
      "We provide expert care and surgical services for Veterans with conditions and diseases that affect the brain, spine and nervous system.",
      "If you have a condition or disease that affects the brain, spine, or nervous system, we can help. We offer expert care and surgery when needed.",
      ["neurosurgeries"],
      ["neurosugery", "neruosurgery", "neurosurgury", "neurosurgary"],
      [
        "neurosurgical",
        "brain surgery",
        "spinal surgery",
        "neurological operation",
        "neuro"
      ]
    ],
    [
      "Home loans",
      null,
      [],
      "VAHomeLoanAssistance",
      null,
      false,
      true,
      false,
      false,
      23,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "HIV/hepatitis care",
      null,
      ["HIV/AIDS", "hepatitis A/B/C"],
      "hiv",
      "Specialty care",
      false,
      false,
      true,
      false,
      21,
      "If you have a diagnosis of HIV or hepatitis A, B or C, we can provide you with the latest treatment methods and support. We also offer prevention education and testing for these infectious diseases.",
      "",
      ["HIV/hepatitis cares"],
      [
        "HIV/haptitis care",
        "HVI/hepatitis care",
        "HI V/heptitis care",
        ";IV/hepatitsis care"
      ],
      [
        "infectious disease care",
        "HIV treatment",
        "hepatitis treatment",
        "viral disease management",
        "hiv prep",
        "PrEP",
        "hep C"
      ]
    ],
    [
      "Life Insurance",
      null,
      [],
      "InsuranceClaimAssistanceAndFinancialCounseling",
      null,
      false,
      true,
      false,
      false,
      20,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "VetSuccess on Campus",
      null,
      [],
      "VetSuccessOnCampus",
      null,
      false,
      true,
      false,
      false,
      20,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Transplant surgery",
      null,
      [],
      "transplantSurgery",
      "Specialty care",
      null,
      null,
      true,
      null,
      19,
      "We are experts in life-saving transplants, including kidney, liver, heart, lung, small bowel, bone marrow and stem cell.",
      "",
      ["transplant surgeries"],
      [
        "transpant surgery",
        "transpalnt surgery",
        "trransplant surgery",
        "trasplant surgery"
      ],
      [
        "transplant operation",
        "organ transplant",
        "transplantation surgery",
        "donor surgery",
        "soild organ transplant",
        "heart transplant",
        "kidney transplant",
        "liver transplant",
        "pancreas transplant",
        "stem cell transplant",
        "small bowel transplant",
        "CAR-T therapy"
      ]
    ],
    [
      "Internal medicine",
      "Internist",
      [],
      "internalMedicine",
      "Primary care",
      false,
      false,
      true,
      false,
      19,
      "Your internal medicine physician (internist) guides your care and connects you with the treatments and services you need.",
      "",
      ["internal medicines"],
      [
        "interal medicine",
        "interal madicine",
        "internal medcine",
        "inernal medicine"
      ],
      [
        "internal doctor",
        "general medicine",
        "internist care",
        "adult medicine"
      ]
    ],
    [
      "Cardiovascular surgery",
      "Heart surgery",
      [],
      "cardiovascularSurgery",
      "Specialty care",
      false,
      false,
      true,
      false,
      18,
      "When treatment of your heart condition calls for surgery, our cardiovascular surgery service offers expert consultation, treatment and care.",
      "",
      ["cardiovascular surgeries"],
      [
        "cardiovasculr surgery",
        "cardivascular surgery",
        "cardovascular surgury",
        "cardiovasculer surgey"
      ],
      [
        "cardiac surgery",
        "heart operation",
        "coronary surgery",
        "vascular surgery",
        "open heart surgery"
      ]
    ],
    [
      "Pre-need burial planning",
      null,
      [],
      "PreNeedBurialPlanning",
      null,
      false,
      true,
      false,
      false,
      18,
      "",
      "",
      [],
      [],
      []
    ],
    [
      "Wheelchair and mobility",
      "Wheelchairs, scooters and custom seating",
      [],
      "mobility",
      "Specialty care",
      false,
      false,
      true,
      false,
      15,
      "We provide support and assistive devices, including wheelchairs, scooters, walkers and canes, to help you preserve and increase your mobility.",
      "",
      ["wheelchair and mobilities"],
      [
        "whellchair and mobilty",
        "wheelchiar and mobility",
        "wheelchari and mobility",
        "wheechair and mobility"
      ],
      [
        "mobility aids",
        "wheelchair care",
        "mobility support",
        "adaptive equipment",
        "walker"
      ]
    ],
    [
      "Bariatric surgery",
      "Weight loss surgery",
      [],
      "bariatricSurgery",
      "Specialty care",
      false,
      false,
      true,
      false,
      14,
      "Bariatric surgery is an approach to help you improve your health and quality of life by losing weight.",
      "",
      ["bariatric surgeries"],
      [
        "bariatric surgury",
        "bariatrc surgery",
        "bariatric surgary",
        "bariatis surgery"
      ],
      [
        "weight reduction surgery",
        "bariatric procedure",
        "metabolic surgery",
        "obesity surgery",
        "stomach stapling",
        "gastric banding",
        "gastric bypass",
        "gastric sleeve"
      ]
    ],
    [
      "Speech pathology",
      "Speech",
      [
        "trouble swallowing (dysphagia)",
        "aphasia",
        "stuttering",
        "speech disorders (dysarthria or apraxia)",
        "cognitive (memory",
        "organization",
        "executive function)"
      ],
      "speech",
      "Specialty care",
      false,
      false,
      true,
      false,
      13,
      "If you have difficulty speaking or understanding what other people are saying, we diagnose and treat problems with fluency, voice, understanding, and other communication disorders. We also diagnose and treat problems that affect your ability to swallow.",
      "",
      ["speech pathologies"],
      [
        "sppech pathology",
        "speech pathlogy",
        "sepech pathology",
        "speach pathology"
      ],
      [
        "speech therapist",
        "speech therapy",
        "speech language pathologist",
        "communication disorder treatment",
        "SLP"
      ]
    ],
    [
      "Colon and rectal surgery",
      null,
      [],
      "colonSurgery",
      "Specialty care",
      false,
      false,
      true,
      false,
      12,
      "We offer compassionate, expert care and surgical services to Veterans with conditions affecting the small bowel, colon, rectum and pelvic floor.",
      "If you have problems in your small intestine, colon, rectum, or pelvic area, we can help. Our compassionate and skilled team can provide surgery when needed.",
      ["colon and rectal surgeries"],
      [
        "clon and rectal surgery",
        "colon and rectl surgury",
        "colon and recctal surgery",
        "colon and rectul surgery"
      ],
      [
        "colorectal surgery",
        "bowel surgery",
        "rectal operation",
        "gastrointestinal surgery",
        "rectum",
        "colon",
        "GI surgery"
      ]
    ],
    [
      "Adaptive sports",
      null,
      [],
      "adaptiveSports",
      "Social programs and services",
      false,
      false,
      true,
      false,
      12,
      "Our adaptive sports program helps disabled Veterans live active and healthy lives through recreation and athletics.",
      "Our adaptive sports program helps you stay active and healthy while living with a disability.",
      ["adaptive sport", "para sport"],
      [
        "adptive sports",
        "adaptve sports",
        "adappative sports",
        "adapative sports",
        "parasport",
        "parasports"
      ],
      [
        "adaptive sport",
        "sport adaptations",
        "athletic rehabilitation",
        "physical activities",
        "adaptive rehab",
        "para sports",
        "disabled sports",
        "wheelchair games",
        "golden age games"
      ]
    ],
    [
      "Outpatient surgery",
      "Ambulatory surgery, day surgery, same-day surgery",
      [],
      "outpatientSurgery",
      "Specialty care",
      false,
      false,
      true,
      false,
      12,
      "Our team cares for you if you need surgery but don't have to stay overnight in the hospital.",
      "",
      ["outpatient surgeries"],
      [
        "outpatient sugery",
        "outpatent surgery",
        "outpaitent surgery",
        "outpatien surgery"
      ],
      [
        "outpatient operation",
        "ambulatory care",
        "same-day surgery",
        "minor surgery"
      ]
    ],
    [
      "Chaplain services",
      "Spiritual care, pastoral  care",
      [],
      "chaplain",
      "Social programs and services",
      false,
      false,
      true,
      false,
      11,
      "VA Chaplains address spiritual, emotional, moral, religious, and ethical concerns of VA patients. Their services are available to religious and non-religious inpatient and outpatient Veterans, their caregivers, and their families. They provide spiritual care and supportive services for survivors. Chaplains are available 24/7 upon request.",
      "",
      ["chaplain services", "prayer services"],
      [
        "chaplen services",
        "chpalain services",
        "chaplain serices",
        "chaplin services"
      ],
      [
        "chaplaincy",
        "pastoral services",
        "spiritual care",
        "religious services",
        "Church",
        "religion",
        "pastor",
        "priest",
        "chaplain",
        "prayer service",
        "last rites",
        "spiritual"
      ]
    ],
    [
      "Hospital medicine",
      null,
      [],
      "hospitalMedicine",
      "Specialty care",
      false,
      false,
      true,
      false,
      8,
      "Our team of hospital physicians (hospitalists) oversees your care during your hospital stay.",
      "",
      ["hospital medicines"],
      [
        "hospitl medicine",
        "hospital medcine",
        "hospital madicine",
        "hospitil medicine"
      ],
      [
        "hospital care",
        "hospitalist",
        "inpatient care",
        "medical ward",
        "inpatient unit",
        "hospital unit"
      ]
    ],
    [
      "Surgical oncology",
      "Cancer surgery",
      [],
      "surgicalOncology",
      "Specialty care",
      null,
      null,
      true,
      null,
      7,
      "If your cancer requires surgery, the surgical oncology service works with your health care team to give expert diagnosis and treatment.",
      "",
      ["surgical oncologies"],
      [
        "surgicl oncology",
        "surgical oncolgy",
        "sugrical oncology",
        "surgcal oncology"
      ],
      [
        "oncological surgery",
        "cancer operation",
        "cancer surgery",
        "tumor surgery"
      ]
    ],
    [
      "Genomic medicine/medical genetics",
      null,
      [],
      "genomicMedicine",
      "Specialty care",
      false,
      false,
      true,
      false,
      6,
      "We make sure you have access to state-of-the-art genetic counseling and diagnostic testing.",
      "",
      ["genomic medicine", "medical genetics"],
      [
        "genomic medcine",
        "genmic medicine",
        "genmic genetics",
        "genomaic medicine medgenics"
      ],
      [
        "genetic medicine",
        "genetic care",
        "DNA analysis",
        "hereditary disease management"
      ]
    ],
    [
      "Virtual Health Resource Center (VHRC)",
      "Technical support and training",
      [],
      "virtualHealthSupport",
      "Other services",
      false,
      false,
      true,
      false,
      6,
      "Virtual Health Resource Centers (VHRCs), located in VA medical centers, offer technical support to Veterans, family members, and caregivers who need help using virtual care tools such as VA Video Connect, My HealtheVet, remote medical monitoring devices, and VA mobile apps. You can make a VHRC appointment for technical guidance, help setting up a VA-loaned device, hands-on support, training, and troubleshooting, and other help with virtual care tools. We are available on the phone, through video, and in person.",
      "",
      ["Virtual Health Resource Centers"],
      [
        "Virtual Health Resourse Center",
        "Virtul Health Resource Center",
        "Virtual Heath Resource Center",
        "Virtual Health resourcee Center"
      ],
      [
        "health support",
        "virtual health help",
        "technical health support",
        "virtual consultations",
        "virtual care",
        "VA device",
        "VA telehealth",
        "VA virtual health"
      ]
    ],
    [
      "Case management",
      null,
      [],
      "caseManagement",
      "Social programs and services",
      false,
      false,
      true,
      true,
      1,
      "",
      "We can help you work better with your TRICARE health care team through our case management support. ",
      ["case managements"],
      ["case managment", "cse mangement", "kase management", "case managemant"],
      [
        "case managers",
        "management",
        "care coordination",
        "social work support",
        "nurse management",
        "social work",
        "social worker",
        "care manager",
        "RN care"
      ]
    ],
    [
      "Operational medicine",
      null,
      [],
      "operationalMedicine",
      "Specialty care",
      false,
      false,
      true,
      true,
      1,
      "",
      "We offer health assessments and screenings that you may need before joining the military, going overseas, re-enlisting, or joining other special programs.",
      ["operational medicines"],
      [
        "opertional medicine",
        "operationaal medicine",
        "operational medcine",
        "operatinal medicine"
      ],
      [
        "operational health",
        "field medicine",
        "medical operations",
        "deployment medicine",
        "surgery"
      ]
    ],
    [
      "Pediatrics",
      null,
      [],
      "pediatrics",
      "Specialty care",
      false,
      false,
      true,
      true,
      1,
      "",
      "We provide high-quality, comprehensive, and family-centered health care. We offer immunizations and other health care to military-dependent children from when they're born to when they turn 18. ",
      ["pediatrics"],
      ["pedatrics", "pediatrics", "pediatricks", "peditarics"],
      [
        "child care",
        "pediatrician",
        "children's health",
        "pediatric care",
        "kid",
        "kids",
        "children"
      ]
    ],
    [
      "Family practice",
      null,
      [],
      "familyPractice",
      "Primary care",
      false,
      false,
      true,
      true,
      1,
      "",
      "We offer comprehensive health care, including immunizations, that puts you and your family at the center. Our team is compassionate, efficient, and professional. ",
      ["family practices"],
      [
        "famlly practice",
        "famly practic",
        "family practcie",
        "famili practice"
      ],
      [
        "general practice",
        "family medicine",
        "primary care",
        "general physician",
        "general doctor"
      ]
    ],
    [
      "Women centered care",
      null,
      [
        "women's primary care",
        "mental health",
        "obstetrics",
        "gynecology",
        "pap smear",
        "mammogram"
      ],
      "tricareWomenCenteredCare",
      "Primary care",
      false,
      false,
      true,
      true,
      1,
      "",
      "We offer women's health services to meet your specific needs. We provide disease screenings, mental health treatment, recovery from military sexual trauma, maternity care, and female-specific medical equipment.",
      ["women centered cares"],
      [
        "womeen centered care",
        "wmon centered care",
        "womenn centered care",
        "wome centered care"
      ],
      [
        "women's care",
        "female health",
        "reproductive care",
        "maternal health",
        "birth control",
        "OB",
        "gyn",
        "ob/gyn",
        "menopause",
        "fertility",
        "maternity"
      ]
    ],
    [
      "LGBQ+ care",
      "Lesbian, gay, bisexual, those with gender dysphoria, and queer/questioning identities",
      [],
      "tricareLbgtqCare",
      "Social programs and services",
      false,
      false,
      true,
      true,
      1,
      "",
      "We serve all TRICARE beneficiaries and their families. The care coordinator at your health care facility can help connect you to services in a safe environment.",
      ["LGBQ+ cares"],
      ["LGB care", "LBGQ+ care", "LGBQ+ car", "LGQ+ care"],
      [
        "LGBTQ care",
        "gender dysphoria help",
        "queer health",
        "diverse identity care"
      ]
    ]
  ]
}
